import { useCallback } from 'react';
import { useStore } from '../stores/toastStore';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
}

export const useToast = () => {
  const { addToast, removeToast, toasts } = useStore();

  const showToast = useCallback((toast: Omit<Toast, 'id'>) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    const newToast = {
      ...toast,
      id,
      duration: toast.duration ?? 5000,
    };
    
    addToast(newToast);
    
    if (newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id);
      }, newToast.duration);
    }
    
    return id;
  }, [addToast, removeToast]);

  return {
    toasts,
    addToast: showToast,
    removeToast,
  };
};